import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = { class: "main-nav__category-title-text" };
const _hoisted_3 = ["title"];
const _hoisted_4 = { class: "main-nav__category-rail-label" };
const _hoisted_5 = { class: "main-nav__category-items" };
const _hoisted_6 = {
    key: 0,
    class: "main-nav__category-items-title"
};
import { computed } from "vue";
import Icon from "./Icon.vue";
import NavigationItem from "./NavigationItem.vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { groupNavItems, isNavItemDisplayable } from "../util/NavUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Navigation',
    props: {
        type: {},
        items: {},
        translationPrefix: {},
        variant: {},
        iconStyle: {},
        grouped: { type: Boolean },
        categories: {},
        collapsedCategories: {}
    },
    emits: [
        'category-toggle'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { t, te } = useI18n();
        const router = useRouter();
        const visibleItems = computed(() => props.items
            .filter(item => shouldDisplayItem(item)));
        const groups = computed(() => groupNavItems(visibleItems.value));
        function categoryLabel(category) {
            const label = findCategory(category)?.label;
            if (label) {
                return te(label) ? t(label) : label;
            }
            const key = 'nav.category.' + category;
            return te(key) ? t(key) : category;
        }
        function categoryShortLabel(category) {
            const shortLabel = findCategory(category)?.shortLabel;
            if (shortLabel) {
                return te(shortLabel) ? t(shortLabel) : shortLabel;
            }
            const key = 'nav.category.' + category + '.short';
            return te(key) ? t(key) : categoryLabel(category);
        }
        function categoryIcon(category) {
            return findCategory(category)?.icon ?? 'folder';
        }
        function findCategory(category) {
            return (props.categories ?? []).find(c => c.name === category);
        }
        function isCollapsed(category) {
            return !!category && (props.collapsedCategories ?? []).indexOf(category) !== -1;
        }
        function toggleCategory(category) {
            emit('category-toggle', category);
        }
        function shouldDisplayItem(item) {
            return isNavItemDisplayable(item, router);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("nav", {
                class: _normalizeClass([(__props.type ?? 'main') + '-nav', (__props.type ?? 'main') + '-nav--' + (__props.variant ?? '')])
            }, [
                (__props.grouped)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(groups.value, (group) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: group.category ?? '',
                            class: _normalizeClass(["main-nav__category", {
                                    'main-nav__category--titled': !!group.category,
                                    'main-nav__category--collapsed': isCollapsed(group.category)
                                }])
                        }, [
                            (group.category)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("a", {
                                        onClick: _withModifiers(($event) => (toggleCategory(group.category)), ["prevent", "stop"]),
                                        href: "",
                                        class: "main-nav__category-title"
                                    }, [
                                        _createElementVNode("span", _hoisted_2, _toDisplayString(categoryLabel(group.category)), 1),
                                        _cache[0] || (_cache[0] = _createTextVNode()),
                                        _createVNode(Icon, {
                                            name: "angle-down",
                                            "icon-style": "light",
                                            class: "main-nav__category-title-icon"
                                        })
                                    ], 8, _hoisted_1),
                                    _cache[2] || (_cache[2] = _createTextVNode()),
                                    _createElementVNode("div", {
                                        class: "main-nav__category-rail",
                                        title: categoryLabel(group.category),
                                        tabindex: "0"
                                    }, [
                                        _createVNode(Icon, {
                                            name: categoryIcon(group.category),
                                            "icon-style": __props.iconStyle ?? 'regular',
                                            class: "main-nav__category-rail-icon"
                                        }, null, 8, ["name", "icon-style"]),
                                        _cache[1] || (_cache[1] = _createTextVNode()),
                                        _createElementVNode("span", _hoisted_4, _toDisplayString(categoryShortLabel(group.category)), 1)
                                    ], 8, _hoisted_3)
                                ], 64))
                                : _createCommentVNode("", true),
                            _cache[4] || (_cache[4] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_5, [
                                (group.category)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(categoryLabel(group.category)), 1))
                                    : _createCommentVNode("", true),
                                _cache[3] || (_cache[3] = _createTextVNode()),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                                    return (_openBlock(), _createBlock(NavigationItem, {
                                        key: item.name,
                                        item: item,
                                        type: __props.type,
                                        "translation-prefix": __props.translationPrefix,
                                        "icon-style": __props.iconStyle
                                    }, null, 8, ["item", "type", "translation-prefix", "icon-style"]));
                                }), 128))
                            ])
                        ], 2));
                    }), 128))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(visibleItems.value, (item) => {
                        return (_openBlock(), _createBlock(NavigationItem, {
                            key: item.name,
                            item: item,
                            type: __props.type,
                            "translation-prefix": __props.translationPrefix,
                            "icon-style": __props.iconStyle
                        }, null, 8, ["item", "type", "translation-prefix", "icon-style"]));
                    }), 128))
            ], 2));
        };
    }
});
